import React from "react";
import { PlayerCard } from "./player-card";

export function WindowSection({ window: w, batters, pitchers, headshotMap, cutoff }) {
  if (batters.length === 0 && pitchers.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6">
      <div className="px-5 py-3 bg-gray-50 border-b border-gray-200">
        <h2 className="text-xs font-semibold text-gray-600 uppercase tracking-widest">
          Last {w} PA / BF
        </h2>
      </div>
      <div className="p-5">
        {batters.length > 0 && (
          <div className={pitchers.length > 0 ? "mb-5" : ""}>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-3">
              Hitters
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {batters.map((p) => (
                <PlayerCard
                  key={p.player_id}
                  player={p}
                  playerType="batter"
                  headshotUrl={headshotMap[p.player_id]}
                  cutoff={cutoff}
                />
              ))}
            </div>
          </div>
        )}
        {pitchers.length > 0 && (
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-3">
              Pitchers
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {pitchers.map((p) => (
                <PlayerCard
                  key={p.player_id}
                  player={p}
                  playerType="pitcher"
                  headshotUrl={headshotMap[p.player_id]}
                  cutoff={cutoff}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
